module.exports = __webpack_public_path__ + "static/img/logo.11484d88.png";